<template>
  <div class="swiper-wrap" v-if="list.length">
    <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
      <swiper-slide :key="index" v-for="(item ,index) in list">
        <img class="item" :src="item.img" :alt="index" @click="go(item.link)" />
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination" v-if="list.length>2"></div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import XHR from '../api'

import 'swiper/dist/css/swiper.css'
export default {
  name: 'HeadSwiper',
  props: [],
  data: () => ({
    list: [],
    swiperOptionTop: {
      // loop: true,
      spaceBetween: 0,
      // loopedSlides: 4,
      navigation: {
        nextEl: '#enjoy-img-next',
        prevEl: '#enjoy-img-prev'
      },
      pagination: {
        el: '.swiper-pagination'
      },
      // 自动播放
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      }
    }
  }),
  components: {
    swiper,
    swiperSlide
  },
  created () {
  },
  mounted () {
    this.getHandWork()
  },
  computed: {
  },
  methods: {
    getHandWork () {
      XHR.getHandWork({
        type: 27,
        hid: 4114
      }).then(res => {
        const { status, data } = res.data
        if (!status) {
          this.list = data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    go (url) {
      if (url) {
        window.location.href = url
      }
    }
  }
}
</script>
<style lang="less" scoped>
.swiper-wrap {
  position: relative;
  height: 160px;
  width: 343px;
  margin: auto;
  box-shadow: 0 8px 24px 0 rgba(61,114,245,0.40);
  .swiper-container {
    height: 100%;
    img {
      height: 100%;
      width: 100%;
    }
    .text {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .swiper-pagination {
    position: absolute;
    bottom: 8px;
    right: 8px;
    display: flex;
    align-items: center;
    height: 12px;
    background: rgba(0, 0, 0, 0.2);
    padding: 0 6px;
    /deep/.swiper-pagination-bullet {
      border-radius: 0;
      width: 6px;
      height: 4px;
      background: rgba(255, 255, 255);
      margin: 0 2px;
    }
    /deep/ .swiper-pagination-bullet-active {
      border-radius: 0;
      width: 10px;
      height: 4px;
      background: #ffffff;
    }
  }
}
@media screen and (min-width: 376px) {
  .swiper-wrap {
    width: 1200px;
    height: 560px;
    margin: auto;
    .swiper-pagination {
      position: absolute;
      bottom: 20px;
      right: 20px;
      display: flex;
      align-items: center;
      height: 24px;
      background: rgba(0, 0, 0, 0.2);
      padding: 0 8px;
      /deep/.swiper-pagination-bullet {
        border-radius: 0;
        width: 12px;
        height: 8px;
        background: rgba(255, 255, 255);
        margin: 0 4px;
      }
      /deep/ .swiper-pagination-bullet-active {
        border-radius: 0;
        width: 20px;
        height: 8px;
        background: #ffffff;
      }
    }
  }
}
</style>
